import { useSsSelector } from '~SpectateStore';
import {
    selectCategorySlugByEventId,
    selectIsUsFormat,
} from '~SpectateStore/selectors/categoriesSelectors';

export const useCategorySlugByEventId = eventId => useSsSelector(state => selectCategorySlugByEventId(state, eventId));
export const useIsUsFormat = eventId => useSsSelector(state => selectIsUsFormat(state, eventId));
